import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import formCadastroEvento from "../schemas/forms";
import { ChangeEvent } from "react";
import FormField from "./EventoFormField";
import { InputAdornment } from "@mui/material";
import { currencyMaskBRL } from "helpers/utils";

const { formField } = formCadastroEvento;
const {
  taxaInscricao,
  qtdParcelaCartao,
  taxaDescontoBoletoEq,
  dataVencPix,
  dataVencBoleto,
  dataVencCartao,
  isentarMorador,
} = formField;

interface FieldTaxaAdmProps {
  values: {
    [x: string]: string;
  };
  handleBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  handleChange: {
    (e: ChangeEvent<any>): void;
    <T = string | ChangeEvent<any>>(
      field: T
    ): T extends ChangeEvent<any>
      ? void
      : (e: string | ChangeEvent<any>) => void;
  };
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  checkedIsentarMorador: boolean;
  handlerIsentarMorador: (
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => void;
}

export default function FieldTaxaAdm({
  values,
  handleBlur,
  handleChange,
  setFieldValue,
  checkedIsentarMorador,
  handlerIsentarMorador,
}: FieldTaxaAdmProps) {
  return (
    <Card id="tax-admin" sx={{ overflow: "visible", margin: "10px 0" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Taxas administrativas</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Defina os valores e regras aplicáveis às taxas administrativas do
          evento.
        </MDTypography>
      </MDBox>

      <MDBox pb={3} px={3}>
        <MDBox display="flex" alignItems="center" mb={2} sx={{ py: 1 }}>
          <MDBox mt={0.5}>
            <Switch
              checked={checkedIsentarMorador}
              onChange={() => handlerIsentarMorador(setFieldValue)}
              color="info"
            />
          </MDBox>
          <MDBox ml={0.5} flex={1}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              {isentarMorador.label}
            </MDTypography>
            <MDTypography variant="caption" display="block" color="text">
              Quando ativado, moradores da cidade do evento podem ter isenção de
              taxa.
            </MDTypography>
          </MDBox>
        </MDBox>

        <Grid container spacing={3} sx={{ my: 1 }}>
          <Grid item xs={12} sm={4}>
            <FormField
              type={taxaInscricao.type}
              label={taxaInscricao.label}
              name={taxaInscricao.name}
              // error={Boolean(touched.taxaInscricao && errors.taxaInscricao)}
              required
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              variant="outlined"
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setFieldValue(
                  taxaInscricao.name,
                  currencyMaskBRL(event.target.value)
                )
              }
              onBlur={handleBlur}
              value={currencyMaskBRL(values.taxaInscricao ?? "0")}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormField
              type={qtdParcelaCartao.type}
              label={qtdParcelaCartao.label}
              name={qtdParcelaCartao.name}
              // error={Boolean(touched.qtdParcelaCartao && errors.qtdParcelaCartao)}
              required
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.qtdParcelaCartao}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormField
              type={taxaDescontoBoletoEq.type}
              label={taxaDescontoBoletoEq.label}
              name={taxaDescontoBoletoEq.name}
              //   error={Boolean(touched.taxaDescontoBoletoEq && errors.taxaDescontoBoletoEq)}
              required
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.taxaDescontoBoletoEq}
              inputProps={{ min: 0, max: 100, step: 0.01 }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ my: 1 }}>
          <Grid item xs={12} sm={4}>
            <FormField
              type={dataVencPix.type}
              label={dataVencPix.label}
              name={dataVencPix.name}
              //   error={Boolean(touched.dataVencPix && errors.dataVencPix)}
              required
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.dataVencPix}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormField
              type={dataVencBoleto.type}
              label={dataVencBoleto.label}
              name={dataVencBoleto.name}
              //   error={Boolean(touched.dataVencBoleto && errors.dataVencBoleto)}
              required
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.dataVencBoleto}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormField
              type={dataVencCartao.type}
              label={dataVencCartao.label}
              name={dataVencCartao.name}
              //   error={Boolean(touched.dataVencCartao && errors.dataVencCartao)}
              required
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.select()
              }
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.dataVencCartao}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
